// Partnership IDs for different environments and different intervals (monthly and yearly)

export const NANIT_PARTNERSHIP_IDS_MONTHLY = [
  'partnership_2xmSBLE1SefXmXrsEc5OAhFffab', // dev
  'partnership_2xoswPEYjI9OVhAVZxtVxxrlNHK', // sandbox
  'partnership_2xotHCwRm7xeXPcMDjmCTpISMwO', // prod
] as const;

export const NANIT_PARTNERSHIP_IDS_YEARLY = [
  'partnership_2umTzzEVS8C2mL7ebABpxNPOto5', // dev
  'partnership_2v5LawHohuOaNIJZfI0SjeoE55W', // sandbox
  'partnership_2urufRaibwceTpQIMfO8urhUTbT', // prod
] as const;

export const NANIT_PARTNERSHIP_IDS = [
  ...NANIT_PARTNERSHIP_IDS_MONTHLY,
  ...NANIT_PARTNERSHIP_IDS_YEARLY,
] as const;

export const NANIT_COUPON_IDS = [
  'InZbqYwo', // dev
  'Aumm0kYQ', // dev monthly
  'InZbqYwo', // sandbox
  'Aumm0kYQ', // sandbox monthly
  'BJDysLAH', // prod
  '2WTjfG32', // prod monthly
] as const;

const NANIT_PROMO_CODES_MONTHLY = ['NANIT65234', 'nanit65234'];
const NANIT_PROMO_CODES_YEARLY = ['NANIT83210', 'nanit83210'];

const NANIT_PROMO_CODES = [
  ...NANIT_PROMO_CODES_MONTHLY,
  ...NANIT_PROMO_CODES_YEARLY,
] as const;

const NANIT_CONTENTFUL_TITLES = ['nanit-yearly', 'nanit-monthly'];

export const isNanitPartnershipId = (partnershipId?: string): boolean =>
  NANIT_PARTNERSHIP_IDS.includes(
    partnershipId as (typeof NANIT_PARTNERSHIP_IDS)[number],
  );

export const isNanitPromoCode = (promoCode?: string): boolean =>
  NANIT_PROMO_CODES.includes(promoCode as (typeof NANIT_PROMO_CODES)[number]);

export const isNanitMonthlyPromoCode = (promoCode?: string): boolean =>
  NANIT_PROMO_CODES_MONTHLY.includes(
    promoCode as (typeof NANIT_PROMO_CODES_MONTHLY)[number],
  );

export const isNanitYearlyPromoCode = (promoCode?: string): boolean =>
  NANIT_PROMO_CODES_YEARLY.includes(
    promoCode as (typeof NANIT_PROMO_CODES_YEARLY)[number],
  );

export const isNanitCouponId = (couponId?: string): boolean =>
  NANIT_COUPON_IDS.includes(couponId as (typeof NANIT_COUPON_IDS)[number]);

export const isNanitContentfulTitle = (title?: string): boolean =>
  NANIT_CONTENTFUL_TITLES.includes(
    title as (typeof NANIT_CONTENTFUL_TITLES)[number],
  );
